import delegate from 'delegate';
import { LitPopupElement } from '../custom-elements/LitPopupElement/LitPopupElement';

let teamPopup: HTMLElement | null;
let teamVideoOpenerDelegation: any;

function onVideoPopupCloseComplete(this: LitPopupElement) {
    const iframe = this.querySelector<HTMLIFrameElement>('iframe.js-product-team-iframe');

    if (iframe) {
        iframe.src = '';
    }
}

function init(container: Element | Document = document) {
    teamPopup = container.querySelector<LitPopupElement>('app-lit-popup[data-lit-popup="product-video-popup"]');

    teamVideoOpenerDelegation = delegate(container, '.js-product-team-video-opener', 'click', (event: any) => {
        const target = event.delegateTarget as HTMLElement;
        const iframe = teamPopup?.querySelector<HTMLIFrameElement>('iframe.js-product-team-iframe');

        if (target.dataset.video && iframe) {
            iframe.src = target.dataset.video;
        }
    });
    teamPopup?.addEventListener('close-complete', onVideoPopupCloseComplete);
}

function destroy() {
    teamPopup?.removeEventListener('close-complete', onVideoPopupCloseComplete);

    if (teamVideoOpenerDelegation) {
        teamVideoOpenerDelegation.destroy();
        teamVideoOpenerDelegation = null;
    }
}

const module = { init, destroy };

export default module;
